import * as React from "react";
import "./EightByEightChat.css";

interface EightByEightChatProps {
    enabled: boolean;
    uri?: string;
    channelUuid?: string;
    channelName?: string;
    tenant?: string;
    scriptUuid?: string;
}

export const EightByEightChat = ({
    enabled,
    uri,
    channelUuid,
    channelName,
    tenant,
    scriptUuid,
}: EightByEightChatProps) => {
    const initializedRef = React.useRef(false);

    React.useEffect(() => {
        if (!enabled || !uri) {
            cleanupChat();
            initializedRef.current = false;
            return;
        }

        if (initializedRef.current) return;
        initializedRef.current = true;

        const scriptId = "eightbyeight-chat-script";
        const buttonContainerId =
            `__8x8-chat-button-container-${scriptUuid}`;

        (function(c, f, ef) {
            var typeofC = Object.prototype.toString.call(c);
            var props = (typeofC === '[object Object]' && c) || {};
            var cb = f || (typeofC === '[object Function]' && c);
            const config = {
                scriptUuid: scriptUuid,
                tenant,
                channelName,
                channelUuid,
                domain: uri,
                buttonContainerId,
                align: "right",
                themeCustom: {
                    buttonPrimaryTextColor: "#ffffff",
                    buttonPrimaryTextColorDisabled: "#e4e4e4",
                    buttonPrimaryBackgroundColor: "#006ca7",
                    buttonPrimaryBackgroundColorHover: "#005c8e",
                    buttonSecondaryTextColor: "#006ca7",
                    buttonSecondaryTextColorDisabled: "#e4e4e4",
                    buttonSecondaryBackgroundColor: "#ffffff",
                    buttonSecondaryBackgroundColorHover: "#005c8e",
                    buttonBorderRadius: "4px",
                    headerBackgroundColor: "#006ca7",
                    headerTextColor: "#ffffff",
                    headerIconColor: "#ffffff",
                    formElementBackgroundColor: "#ffffff",
                    formElementBorderColor: "#e4e4e4",
                    formElementBorderRadius: "4px",
                },
            };

            const url = new URL(
                "https://cloud8-cc-geo.8x8.com/vcc-chat-channels/public/webchat/discovery"
            );
            const params = {
                domain: config.domain,
                tenant: config.tenant,
                channelUuid: config.channelUuid,
            };
            url.search = new URLSearchParams(params).toString();

            fetch(url)
                .then((response) => response.json())
                .then(data => config.domain = !data.domain ? config.domain : data.domain)
                .catch(error => console.warn('Failed to retrieve override domain, will continue using ', config.domain, error))
                .finally(() => loadChat());

            function loadChat() {
                var se = document.createElement("script");
                se.id = scriptId,
                se.type = "text/javascript";
                se.async = true;
                se.src = props.loaderURL || (config.domain + "/CHAT/common/js/chatv3.js");
                Object.keys(config).forEach(function(k) { se.dataset[k] = config[k] });
                Object.keys(props).forEach(function(k) { se.dataset[k] = props[k] });
                function handleInitEvent(e) {
                    var initFn = e.detail.init;
                    initFn(config, cb);
                    se.removeEventListener('init', handleInitEvent)
                }
                function handleErrorEvent(e) {
                    ef && ef(e);
                    se.removeEventListener('customerror', handleErrorEvent);
                }
                se.addEventListener('init', handleInitEvent);
                se.addEventListener('customerror', handleErrorEvent);
                var os = document.getElementsByTagName("script")[0];
                os.parentNode.insertBefore(se, os);
            }
        })();

        return () => {
            cleanupChat();
            initializedRef.current = false;
        };
    }, [enabled, uri, channelUuid, channelName]);

    const cleanupChat = () => {
        const scripts = document.querySelectorAll("script[data-eightbyeight='true']");
        scripts.forEach((el) => el.parentNode?.removeChild(el));

        const nodes = document.querySelectorAll(
            "[id^='__8x8-chat'], [id^='8x8-'], iframe[src*='8x8'], div[class*='8x8']"
        );
        nodes.forEach((el) => el.parentNode?.removeChild(el));
    };

    return (
        <li>
            <a
                id={`__8x8-chat-button-container-${scriptUuid}`}
                className="supportChat"
                role="button"
            ></a>
        </li>
    );
};
